import { Plus, Trash2 } from 'lucide-react'
import { Button, Input } from '@/components/ui'
import type { PriceTier } from '../api/onboarding-types'

/** Quantity-break sell prices: "from N <unit>, price P per <unit>". */
export function TiersEditor({
  value,
  onChange,
  disabled,
  uom,
}: {
  value: PriceTier[]
  onChange: (next: PriceTier[]) => void
  disabled?: boolean
  uom?: string | null
}) {
  const unit = uom ?? 'unit'
  const set = (i: number, patch: Partial<PriceTier>) => onChange(value.map((t, j) => (j === i ? { ...t, ...patch } : t)))
  const add = () => onChange([...value, { min_quantity: value.length ? '' : '1', price: '' }])
  return (
    <div className="overflow-hidden rounded-lg border border-border-default">
      {value.length ? (
        <table className="w-full border-collapse text-md">
          <thead className="bg-surface-sunk text-left text-sm font-semibold text-secondary">
            <tr>
              <th className="px-4 py-2.5">Order quantity from ({unit})</th>
              <th className="px-4 py-2.5">Price per {unit}</th>
              <th className="w-14 px-2 py-2.5"><span className="sr-only">Remove</span></th>
            </tr>
          </thead>
          <tbody>
            {value.map((t, i) => (
              <tr key={i} className="border-t border-border-subtle">
                <td className="px-4 py-2">
                  <Input aria-label={`Tier ${i + 1} quantity`} inputMode="decimal" value={t.min_quantity} disabled={disabled}
                    onChange={(e) => set(i, { min_quantity: e.target.value })} />
                </td>
                <td className="px-4 py-2">
                  <Input aria-label={`Tier ${i + 1} price`} inputMode="decimal" value={t.price} disabled={disabled}
                    onChange={(e) => set(i, { price: e.target.value })} />
                </td>
                <td className="px-2 py-2 text-center">
                  {!disabled ? (
                    <Button variant="ghost" size="sm" iconOnly aria-label={`Remove tier ${i + 1}`}
                      onClick={() => onChange(value.filter((_, j) => j !== i))}>
                      <Trash2 size={16} />
                    </Button>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="px-4 py-4 text-md text-secondary">
          No quantity breaks. Optional: add one when larger orders get a lower price.
        </p>
      )}
      {!disabled ? (
        <div className="border-t border-border-subtle bg-surface-sunk px-4 py-3">
          <Button variant="secondary" size="sm" onClick={add}>
            <Plus size={16} /> Add quantity break
          </Button>
        </div>
      ) : null}
    </div>
  )
}
